<template>
    <section class="app-main">

  
        <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品语言：
                    </el-col>
                    <el-col :span="22">
                        <el-radio v-model="goods.language" label="zh" border style="width:130px">中文录入</el-radio>
                        <el-radio v-model="goods.language" label="en" border style="width:130px">英文录入</el-radio>
                    </el-col>
                </el-row> 
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品类型：
                    </el-col>
                    <el-col :span="22">
                        <el-radio v-model="goods.goods_type" label="1" border style="width:130px">普通商品</el-radio>
                        <el-radio v-model="goods.goods_type" label="2" border style="width:130px">食品类型</el-radio>
                        <el-radio v-model="goods.goods_type" label="3" border style="width:130px">服务类型</el-radio>
                    </el-col>
                </el-row> 
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        税费类型：
                    </el-col>
                    <el-col :span="22">
                        <el-radio v-model="goods.tax_type" label="1" border style="width:130px">收税</el-radio>
                        <el-radio v-model="goods.tax_type" label="2" border style="width:130px">免税</el-radio>
                    </el-col>
                </el-row>   
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品名称：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-model="name" placeholder="请输入商品名称" style="width:400px"></el-input>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        关联词语：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-model="goods.description" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" placeholder="请输入商品关联词语(空格隔开)" style="width:100%"></el-input>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品分类：
                    </el-col>
                    <el-col :span="22">
                         <el-select v-model="goods.type_id" filterable multiple placeholder="请选择" style="width:400px">
                            <el-option v-for="it in classifyOptions" :key="it.id" :label="goods.language == 'zh' ? it.title : it.title_en" :value="it.id"></el-option>
                        </el-select>
                    </el-col>
                </el-row> 
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品主图：
                    </el-col>
                    <el-col :span="22">
                        <m-upload :img.sync="image"  :width="120" :height="120" file-name="goodsImg"  placement="right" />
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        图片要求：
                    </el-col>
                    <el-col :span="22" class="input-left tips">
                        仅接受JPG、JPEG、PNG格式，200*200
                    </el-col>
                </el-row>
            </el-card>

            <!-- <el-card class="m-bottom-4" v-for="(it,i) in sku" :key="i">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品规格：
                    </el-col>
                    <el-col :span="22">
                        <el-select v-model="it.key" placeholder="选择规格" class="sku-input">
                            <i @click="handleRemoveKey(i,$event)" slot="prefix" class="el-input__icon el-icon-delete"></i>
                            <el-option v-for="item in specData" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                        <el-button plain class="sku-add" @click="handleSkuAdd()">添加规格</el-button>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        规格属性：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-for="(item,index) in it.children" :key="index" v-model="item.value"  placeholder="输入属性名称" class="sku-input">
                            <i @click="handleRemoveValue(index,it.children)" slot="prefix" class="el-input__icon el-icon-delete"></i>
                        </el-input>
                        <el-button plain class="sku-add" @click="handleValueAdd(it.children)">添加属性</el-button>
                    </el-col>
                </el-row>
            </el-card> -->

            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        编辑SKU：
                    </el-col>
                    <el-col :span="22">
                        <!-- <el-button  @click="handleSku()" type="success" plain style="width:120px">确认生成</el-button> -->
                        <el-row style="border:1px solid #dddfe1;padding:10px;min-height:40px" >
                            <el-tag type="info" closable v-for="(it,index) in skuItems" :key="index" style="margin:0 15px 8px 0;" @close="skuReduce(index)">{{it.str}}</el-tag>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4" v-show="skuItems.length != 0">
                    <el-col :span="2" class="input-left">商品SKU:</el-col>
                    <el-col :span="20" style="overflow-y:auto">
                        <div class="sku-items-head">
                            <div><span>规格变量</span></div>
                            <div><span>销售价(C$)</span></div>
                            <div><span>预售价(C$)</span></div>
                            <div><span>代理价(C$)</span></div>
                            <div><span>重量(单位kg)</span></div>
                            <div><span>长(单位cm)</span></div>
                            <div><span>宽(单位cm)</span></div>
                            <div><span>高(单位cm)</span></div>
                            <div><span>条形码</span></div>
                            <div><span>变量图片</span></div>
                        </div>
                        <div class="sku-items-body" v-for="(it,index) in skuItems" :key="index">
                            <div><el-input v-model="it.str"  size="small" ></el-input></div>
                            <div><el-input v-model="it.price"  size="small"  ></el-input></div>
                            <div><el-input v-model="it.pre_sale_price"  size="small"  ></el-input></div>
                            <div><el-input v-model="it.proxy_price"  size="small"  ></el-input></div>
                            <div><el-input v-model="it.goods_weight"  size="small"  ></el-input></div>
                            <div><el-input v-model="it.goods_length"  size="small"  ></el-input></div>
                            <div><el-input v-model="it.goods_width"  size="small"  ></el-input></div>
                            <div><el-input v-model="it.goods_height"  size="small"  ></el-input></div>
                            <div><el-input v-model="it.barcode"  size="small" readonly ></el-input></div>
                            <div style="text-align:center">
                                <m-upload :img.sync="it.skupic"  :width="70" :height="70" file-name="goodsImg"  placement="right" />
                            </div>
                        </div>
                        <el-button  @click="handleSkuCopy()" type="success" plain style="width:120px;margin-top:15px">一键填充</el-button>
                        <div class="sku-tips">Tips：所有属性都要填写，否则会添加商品失败；一键填充将所有的销售价、预售价、重量、长、宽、高等于第一行的数据</div>
                    </el-col>
                </el-row>  
            </el-card>

            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        商品视频：
                    </el-col>
                    <el-col :span="22">
                        <m-video :video.sync="video"  :width="120" :height="120" file-name="goodsVideo" ></m-video>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        视频要求：
                    </el-col>
                    <el-col :span="22" class="input-left tips">
                        （可不上传）仅接受MP4格式，375*375
                    </el-col>
                </el-row>
            </el-card>

            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        轮播图：
                    </el-col>
                    <el-col :span="22">
                        <m-uploads :imgs.sync="banner" :width="120" :height="120" file-name="goodsBanner" ></m-uploads>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        图片要求：
                    </el-col>
                    <el-col :span="22" class="input-left tips">
                       仅接受JPG、JPEG、PNG格式，375*375
                    </el-col>
                </el-row>
            </el-card>

            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        详情图：
                    </el-col>
                    <el-col :span="22">
                        <m-uploads :imgs.sync="details" :width="120" :height="120" file-name="goodsDetails" ></m-uploads>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        图片要求：
                    </el-col>
                    <el-col :span="22" class="input-left tips">
                       仅接受JPG、JPEG、PNG格式，375*375
                    </el-col>
                </el-row>
            </el-card>

            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        售后服务：
                    </el-col>
                    <el-col :span="22">
                        <el-radio v-model="goods.after_sale" label="1" border style="width:130px">七天无理由</el-radio>
                        <el-radio v-model="goods.after_sale" label="2" border style="width:180px">非质量问题不退不换</el-radio>
                        <el-radio v-model="goods.after_sale" label="3" border style="width:180px">商品售出不退不换</el-radio>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        售后说明：
                    </el-col>
                    <el-col :span="22" class="input-left tips">
                       <el-input v-model="goods.after_sale_content" placeholder="请输入售后说明" style="width:570px"></el-input>
                    </el-col>
                </el-row>
            </el-card>

            <el-card>
                <el-row class="m-bottom-4">
                    <el-col :span="2" class="input-left">
                        提交商品：
                    </el-col>
                    <el-col :span="22">
                        <el-button  @click="handleSubmit()" type="success" plain style="width:150px">确认添加</el-button>
                    </el-col>
                </el-row>
            </el-card>
            
        
    </section>
</template>
<script>
import { goods_add } from '@/api/goods.js'
import { classify_list } from '@/api/goods.js'
import MUpload from '@/components/m-upload.vue'
import MVideo from '@/components/m-video.vue'
import MUploads from '@/components/m-uploads.vue'
export default {
    name:'buyUpload',
    components:{ MUpload, MUploads, MVideo },
    props: [ 'name', 'belongs', 'skuItems', 'skuAttr' ],
    data () {
        return {
            image: { url: '', pic_id: '' },   // 主图
            banner: [],
            details: [],
            video: { video_pic: '', video_id: '' },

            goods:{
                language:'zh',
                goods_type: '1',
                tax_type: '1',
                type_id:[],
                description: '',

                after_sale: '1',
                after_sale_content: '',
            },
            classifyOptions:[],
        }
    },
    methods:{


        // 获取分类数据
        getClassify() {
            let params = {
                level:2,
            }
            classify_list(params).then(res => {
                if(res){
                    this.classifyOptions = res.data
                }
            })
        },



        // 删除SkU
        skuReduce(index){
            this.skuItems.splice(index,1)
        },

        // sku 一键复制
        handleSkuCopy() {
            let len = this.skuItems.length
            for(let i=1; i<len; i++ ) {
                this.skuItems[i].price          = this.skuItems[0].price
                this.skuItems[i].pre_sale_price = this.skuItems[0].pre_sale_price
                this.skuItems[i].proxy_price    = this.skuItems[0].proxy_price
                this.skuItems[i].goods_weight   = this.skuItems[0].goods_weight
                this.skuItems[i].goods_length   = this.skuItems[0].goods_length
                this.skuItems[i].goods_width    = this.skuItems[0].goods_width
                this.skuItems[i].goods_height   = this.skuItems[0].goods_height
            }
        },

        
        // 确定上传
        handleSubmit(){

            let details = []
            this.details.forEach(e => {
                details.push(e.pic_id)
            })
            let banner = []
            this.banner.forEach(e => {
                banner.push(e.pic_id)
            })

            let sku = JSON.parse(JSON.stringify(this.skuItems))
            sku.forEach((e) => {
                // e.attr_val[0] = e.str
                // this.skuAttr[0].attr_title = e.str
                e.sku_pic = e.skupic.pic_id
                e.cost_price = e.price
            })
            console.log(sku);
            for(var i=0; i<this.skuAttr.length; i++){
                for(var j=i+1; j<this.skuAttr.length; j++){
                    if(this.skuAttr[i].attr_title==this.skuAttr[j].attr_title){         //第一个等同于第二个，splice方法删除第二个
                        this.skuAttr.splice(j,1);
                        j--;
                    }
                }
            }

            let params = {
                name: this.name,
                belongs: this.belongs,
                language: this.goods.language,
                goods_details: details.join(','),
                goods_type : this.goods.goods_type,
                tax_type   : this.goods.tax_type,
                type_id    : this.goods.type_id.join(','),
                description: this.goods.description,
                warehouse  : 1,
                merchant_id: 1,
                image      : this.image.pic_id,
                round_pic  : banner.join(','),
                after_sale : this.goods.after_sale,
                sku        : sku,
                attr       : this.skuAttr,
            }
            if(this.video.video_id  && this.video.video_id != ''){
                params.video_id = this.video.video_id
            }else {
                params.video_id = 0
            }

            if(this.goods.after_sale_content  != ''){
                params.after_sale_content = this.goods.after_sale_content
            }
            
            if(this.name == ""){
                this.$message.error('请先完善商品名称')
                return false
            }
            if(this.goods.type_id.length == 0){
                this.$message.error('至少选择一个商品分类')
                return false
            }
            if(this.image.pic_id == ""){
                this.$message.error('请先完善商品主图')
                return false
            }
            if(this.skuAttr.length == 0){
                this.$message.error('至少要设置一条规格属性')
                return false
            }

            let skuBol = false
            sku.forEach(params => {
                for(let key in params){
                    if(params[key] === '' || params[key] === undefined || params[key] === null || params[key].length == 0 || params[key].pic_id == ''){
                        skuBol = true   // 终止程序
                    }
                }
            })
            if(skuBol) {
                this.$message.error('请务必完善SKU每条信息')
                return false
            }else {
                sku.forEach(e => {
                    delete e.skupic
                    delete e.str
                })
            }


            if(banner.length == 0){
                this.$message.error('至少上传一轮播图')
                return false
            }
            if(details.length == 0){
                this.$message.error('至少上传一张详情图')
                return false
            }
            


            
            goods_add(params).then(res => {
                if(res){
                   this.$message({type:'success', message:res.msg, duration:1500})
                   this.clearData() 
                   this.$emit('success')
                   
                }
            })
        },

        clearData(){
            this.image  = { url: '', pic_id: '' }   // 主图
            this.banner =  []
            this.details = []
            this.video =  {}


            this.$emit('update:skuItems', [])
            this.$emit('update:skuAttr',  [])
            this.$emit('update:name',     '')
             this.$emit('update:belongs', '')
            this.goods = {
                language:'zh',
                goods_type: '1',
                tax_type: '1',
                after_sale: '1',
                type_id:[],
                description: '',
            }
        },
    },
    created(){
        this.getClassify()
    },
    activated() {
        this.getClassify()
    }
}
</script>
<style lang="less" scoped>
.sizing {
    box-sizing: border-box;
}
section {
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    .tips {
        color: #909399;
        font-size: 14px;
    }
    
    .sku-value {
        height: 40px;
        line-height: 40px;
        margin:20px 15px 0 0;
    }
    .sku-input {
        width: 150px;
        margin-right: 20px;
    }
    .sku-items-head {
        min-width: 1060px;
        display: grid;
        grid-template-columns: 120px repeat(7, 100px) 140px 120px;
        grid-template-rows: 50px;
        background: #f5f7fa;
        border: 1px solid #e8e8e8;
        >div {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            font-size: 15px;
            color: #8c939d;
            >span {
                display: inline-block;
                width: 91.22%;
                height: 36px;
                background: #fff;
                text-align: center;
                line-height: 36px;
            }
        }
    }
        .sku-items-body {
            min-width: 1060px;
            display: grid;
            grid-template-columns: 120px repeat(7, 100px) 140px 120px;
            grid-template-rows: 80px;
            border: 1px solid #e8e8e8;
            border-top: none;
            >div {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 80px;
                padding: 0 10px;
                font-size: 15px;
                color: #8c939d;
                >span {
                    display: inline-block;
                    width: 91.22%;
                    height: 36px;
                    background: #fff;
                    text-align: center;
                    line-height: 36px;
                }
            }
            .avatar-uploader-icon {
                width: 60px;
                height: 60px ;
                line-height: 60px !important;
                border: 1px solid #e0e0e0;
            }
        }
        .sku-tips {
            height: 30px;
            line-height: 30px;
            margin-top: 5px;
            color: red;
        }
}
</style>

